<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-31 16:03:10
 * @FilePath: /wemeet-admin-new/src/views/aiProduct/components/editVenue.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-form ref="formRef" :model="form" :rules="rules">
      <el-form-item label="场地名称" :label-width="80" prop="venueName">
        <el-input v-model="form.venueName" autocomplete="off" maxlength="50" />
      </el-form-item>
      <el-form-item label="场地图片" :label-width="80" prop="imgUrl">
        <el-upload
          accept=".png,.jpeg,.jpg"
          action="#"
          class="upload-demo"
          :file-list="form.fileList"
          :http-request="upCover"
          :limit="1"
          list-type="picture-card"
          :on-error="handleError"
          :on-exceed="handleExceed"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
        >
          <el-icon class="el-icon--upload">
            <upload-filled />
          </el-icon>
          <div class="el-upload__text">
            <em>点击上传文件</em>
          </div>
        </el-upload>
      </el-form-item>
    </el-form>

    <div class="demo-drawer__footer">
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </div>
    <el-dialog v-model="dialogVisibleImg" append-to-body title="查看大图">
      <div>
        <el-image :src="form.imgUrl" />
      </div>
    </el-dialog>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { baseH5URL } from '@/config'
  import { venueSave, venueUpdate } from '@/api/ai'
  import { parseTime } from '@/utils/index'
  import { parse } from 'qs'
  import { upLoadImg } from '@/api/active'
  export default defineComponent({
    name: 'EditRecord',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const validateImg = (rule, value, callback) => {
        if (state.form.imgUrl) {
          callback()
        } else {
          callback(new Error('请上传场地图片'))
        }
      }
      const state = reactive({
        dialogFormVisible: false,
        dialogVisibleImg: false,
        formRef: null,
        direction: 'rtl',
        size: '40%',
        title: '链接地址',
        loading: null,
        form: {},
        registerMobileUrl: [],
        title: '编辑录音',
        total: 0,
        layout: 'total, sizes, prev, pager, next, jumper',
        queryForm: {
          pageSize: 10,
          pageNum: 1,
          scheduleCode: '',
        },
        list: [],

        rules: {
          venueName: [{ required: true, trigger: 'blur', message: '请输入文章标题' }],
          imgUrl: [{ required: true, trigger: 'change', validator: validateImg }],
        },
      })
      // 打开
      const handleOpen = (row) => {
        if (row) {
          console.log(row)
          state.title = '编辑场地'
          row.fileList = [{ name: 'coverUrl', url: row.imgUrl }]
          state.form = JSON.parse(JSON.stringify(row))
        } else {
          state.title = '添加场地'
        }

        state.form.meetingCode = props.meetingCode
        state.form.meetingType = 'EXHIBITION'
        state.dialogFormVisible = true
      }
      // 关闭
      const handleClose = () => {
        state.form = {
          venueName: '',
          imgUrl: '',
          fileList: [],
        }
        state.dialogFormVisible = false
        state['formRef'].resetFields()
      }

      const handlePreview = () => {
        state.dialogVisibleImg = true
      }
      const handleSave = async () => {
        state['formRef'].validate(async (valid) => {
          if (valid) {
            try {
              if (state.form.id) {
                await venueUpdate(state.form)
              } else {
                await venueSave(state.form)
              }
              emit('fetchData')
              proxy.$baseMessage(`操作成功`, 'success', `vab-hey-message-success`)
            } catch (e) {
              proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
            }

            handleClose()
          }
        })
      }

      const upCover = async (e) => {
        let upData = new FormData()
        upData.append('file', e.file)
        const { data } = await upLoadImg(upData)
        state.form.imgUrl = data
      }

      const handleError = (err, file) => {
        proxy.$baseMessage(
          `文件[${file.raw.name}]上传失败,文件大小为${_.round(file.raw.size / 1024, 0)}KB`,
          'error',
          'vab-hey-message-error'
        )
      }

      const handleExceed = (files) => {
        proxy.$baseMessage(
          `当前限制选择 1个文件，本次选择了
               ${files.length}
               个文件`,
          'error',
          'vab-hey-message-error'
        )
      }
      const handleRemove = () => {
        state.form.imgUrl = ''
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleSave,
        handleRemove,
        handleExceed,
        upCover,
        handleError,
        handlePreview,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .el-descriptions {
    height: 80vh;
    overflow: auto;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    display: flex;
    margin-bottom: 5px;
  }
</style>
